module.exports = __webpack_public_path__ + "img/高校院所.59d7cf5a.png";